import { all  } from 'redux-saga/effects';
import LiveSaga from './live/saga';

export default function* rootSaga() {
    yield all([
        LiveSaga(),
    ]);
}
